var map = {
	"./QR_ERC20.png": 34339,
	"./QR_TRC20.png": 24637,
	"./abg-0.png": 56481,
	"./abg-1.png": 58198,
	"./abg-1b.png": 48094,
	"./abg-2.png": 42240,
	"./abg-3.png": 35118,
	"./abg-4.png": 36051,
	"./abg-5.png": 75012,
	"./abg-6.png": 94366,
	"./avatar/a1.png": 89323,
	"./avatar/a2.png": 85327,
	"./avatar/a3.png": 12845,
	"./avatar/a4.png": 11655,
	"./avatar/a5.png": 56594,
	"./avatar/a6.png": 94578,
	"./avatar/a7.png": 88087,
	"./avatar/a8.png": 2267,
	"./avatar/a9.png": 12264,
	"./bg-ab01.png": 25473,
	"./bg-ab02.png": 76284,
	"./bg-ab02b.png": 69558,
	"./bg-ab02c.png": 44562,
	"./bg-ab03.png": 65335,
	"./bg-ab04.png": 35085,
	"./bg-ab05.png": 2693,
	"./bg-ab07.png": 21598,
	"./bg-ab07in.png": 11351,
	"./bg-ab08.png": 93996,
	"./bg-ab09.png": 23728,
	"./bg-ab10.png": 28146,
	"./bg-ab11.png": 9609,
	"./bg-ab12.png": 61273,
	"./bg-ab13.png": 46332,
	"./bg-ab13b.png": 31691,
	"./bg-ab15.png": 34290,
	"./bg-ab15b.png": 9459,
	"./bg01.png": 20539,
	"./bg03-a.png": 65350,
	"./bg03.png": 80154,
	"./bg04.png": 71823,
	"./bg05.png": 39692,
	"./bg05c.png": 89523,
	"./bg06.png": 31451,
	"./bg07.png": 83184,
	"./bg07b.png": 93294,
	"./bg08.png": 33736,
	"./bg09.png": 71612,
	"./bg10.png": 99080,
	"./bg100.png": 41024,
	"./bg101.png": 87902,
	"./bg107.png": 99514,
	"./bg108.png": 58799,
	"./bg109.png": 596,
	"./bg11.png": 6394,
	"./bg111.png": 23928,
	"./bg112.png": 30441,
	"./bg113.png": 56497,
	"./bg121.png": 49149,
	"./bg124.png": 41029,
	"./bg125.png": 61387,
	"./bg126.png": 60198,
	"./bg127.png": 15268,
	"./bg128.png": 25533,
	"./bg129.png": 80684,
	"./bg130.png": 47603,
	"./bg133.png": 18202,
	"./bg133t-png.png": 50658,
	"./bg133t.png": 60939,
	"./bg135.png": 40101,
	"./bg136.png": 82961,
	"./bg138.png": 85665,
	"./bg139.png": 87089,
	"./bg140.png": 43595,
	"./bg144.png": 44975,
	"./bg147.png": 53906,
	"./bg149.png": 71720,
	"./bg149b.png": 7957,
	"./bg15.png": 92552,
	"./bg150.png": 44520,
	"./bg152-a.png": 63782,
	"./bg152-c.png": 46472,
	"./bg152-d.png": 23404,
	"./bg152-m.png": 26383,
	"./bg152-p.png": 75698,
	"./bg152-w.png": 17369,
	"./bg15_1225.png": 27076,
	"./bg15_1225b.png": 54788,
	"./bg15_1225c.png": 75515,
	"./bg15c.png": 50271,
	"./bg16.png": 52970,
	"./bg17-1.png": 38853,
	"./bg17-2.png": 3642,
	"./bg17-3.png": 99819,
	"./bg170.png": 76762,
	"./bg171.png": 90765,
	"./bg18.png": 9498,
	"./bg183.png": 85732,
	"./bg184.png": 93244,
	"./bg185.png": 21173,
	"./bg186.png": 1344,
	"./bg187.png": 47026,
	"./bg188-1.png": 14070,
	"./bg188-2.png": 48409,
	"./bg188-3.png": 65588,
	"./bg188-4.png": 83762,
	"./bg188-5.png": 86910,
	"./bg188-6.png": 70482,
	"./bg188-7.png": 24462,
	"./bg188-9.png": 17688,
	"./bg188b.png": 57652,
	"./bg189-b.png": 95644,
	"./bg189-r.png": 27510,
	"./bg189-y.png": 73727,
	"./bg190-b.png": 36321,
	"./bg190-r.png": 59352,
	"./bg190-y.png": 42167,
	"./bg191.png": 33098,
	"./bg192.png": 18211,
	"./bg193.png": 1868,
	"./bg194.png": 94214,
	"./bg194b.png": 91646,
	"./bg195.png": 41039,
	"./bg200.png": 10127,
	"./bg201.png": 13019,
	"./bg202.png": 18570,
	"./bg203.png": 35536,
	"./bg204.png": 28913,
	"./bg205.png": 6968,
	"./bg206.png": 80843,
	"./bg207.png": 60959,
	"./bg208.png": 90460,
	"./bg20_1225.png": 38339,
	"./bg21.png": 14893,
	"./bg22.png": 43159,
	"./bg23.png": 98452,
	"./bg24.png": 4660,
	"./bg25.png": 78404,
	"./bg26.png": 82005,
	"./bg27.png": 57450,
	"./bg28.png": 33574,
	"./bg30.png": 50265,
	"./bg301.png": 71833,
	"./bg301b.png": 18073,
	"./bg302.png": 83778,
	"./bg303.png": 41142,
	"./bg305.png": 17581,
	"./bg306.png": 31122,
	"./bg308.png": 69279,
	"./bg309.png": 7736,
	"./bg31.png": 26330,
	"./bg310.png": 29919,
	"./bg311.png": 78884,
	"./bg312.png": 18257,
	"./bg313.png": 7580,
	"./bg314.png": 67467,
	"./bg315.png": 80707,
	"./bg316.png": 8661,
	"./bg317.png": 67407,
	"./bg317b.png": 81140,
	"./bg32.png": 5407,
	"./bg33.png": 93632,
	"./bg33b.png": 65148,
	"./bg34.png": 71736,
	"./bg35.png": 55621,
	"./bg36.png": 61344,
	"./bg37.png": 76108,
	"./bg37a.png": 92569,
	"./bg37b.png": 7463,
	"./bg37c.png": 30443,
	"./bg38.png": 32790,
	"./bg38b.png": 44671,
	"./bg39.png": 47946,
	"./bg40.png": 51742,
	"./bg401.png": 91232,
	"./bg41.png": 62112,
	"./bg42.png": 93069,
	"./bg43.png": 21305,
	"./bg44.png": 55545,
	"./bg45.png": 53545,
	"./bg46.png": 89864,
	"./bg47.png": 3100,
	"./bg48.png": 75719,
	"./bg49.png": 10275,
	"./bg50.png": 90630,
	"./bg501.png": 55486,
	"./bg502.png": 22963,
	"./bg503.png": 65527,
	"./bg504.png": 53404,
	"./bg507.png": 66088,
	"./bg508.png": 42722,
	"./bg51.png": 80873,
	"./bg512.png": 90582,
	"./bg52.png": 52008,
	"./bg530.png": 80803,
	"./bg57.png": 24826,
	"./bg57d.png": 72257,
	"./bg57e.png": 85070,
	"./bg57j.png": 47409,
	"./bg58.png": 19655,
	"./bg58b.png": 54941,
	"./bg58c.png": 7324,
	"./bg60.png": 56974,
	"./bg63.png": 92629,
	"./bg64.png": 31992,
	"./bg65.png": 60756,
	"./bg66.png": 12358,
	"./bg67d.png": 87413,
	"./bg77.png": 7614,
	"./bg78.png": 37620,
	"./bg84.png": 76217,
	"./bg84b.png": 7071,
	"./bg87.png": 8346,
	"./bg88.png": 87192,
	"./bg93.png": 88777,
	"./bg93b.png": 99602,
	"./bg95.png": 45763,
	"./bg96.png": 83751,
	"./bg97.png": 12321,
	"./bg98.png": 37743,
	"./bg99.png": 69110,
	"./bg_92.png": 23550,
	"./br/PT/S1/avatar/a1.png": 40867,
	"./br/PT/S1/avatar/a2.png": 9193,
	"./br/PT/S1/avatar/a3.png": 66228,
	"./br/PT/S1/avatar/a4.png": 16505,
	"./br/PT/S1/avatar/a5.png": 56031,
	"./br/PT/S1/avatar/a6.png": 50783,
	"./br/PT/S1/avatar/a7.png": 32982,
	"./br/PT/S1/avatar/a8.png": 69874,
	"./br/PT/S1/avatar/a9.png": 90939,
	"./br/PT/S1/bg-lose.png": 16869,
	"./br/PT/S1/bg-win.png": 7793,
	"./br/PT/S1/bg03-a.png": 10657,
	"./br/PT/S1/bg03-a_1225.png": 57606,
	"./br/PT/S1/bg03.png": 95478,
	"./br/PT/S1/bg03_1225.png": 94989,
	"./br/PT/S1/bg07 - 副本.png": 15970,
	"./br/PT/S1/bg07.png": 41817,
	"./br/PT/S1/bg07b - 副本.png": 673,
	"./br/PT/S1/bg07b.png": 73231,
	"./br/PT/S1/bg105.png": 10605,
	"./br/PT/S1/bg115.png": 45260,
	"./br/PT/S1/bg116.png": 48296,
	"./br/PT/S1/bg117.png": 45641,
	"./br/PT/S1/bg13.png": 9374,
	"./br/PT/S1/bg130.png": 15710,
	"./br/PT/S1/bg131.png": 16165,
	"./br/PT/S1/bg132.png": 98637,
	"./br/PT/S1/bg142.png": 91880,
	"./br/PT/S1/bg143.png": 37680,
	"./br/PT/S1/bg185.png": 69669,
	"./br/PT/S1/bg300.png": 31866,
	"./br/PT/S1/bg301.png": 68573,
	"./br/PT/S1/bg53.png": 48088,
	"./br/PT/S1/bg55.png": 57922,
	"./br/PT/S1/bg59.png": 30928,
	"./br/PT/S1/bg62.png": 14402,
	"./br/PT/S1/bg67.png": 56286,
	"./br/PT/S1/bg67b.png": 50568,
	"./br/PT/S1/bg67c.png": 29395,
	"./br/PT/S1/bg76.png": 46027,
	"./br/PT/S1/bg901.png": 7379,
	"./br/PT/S1/bg903.png": 11143,
	"./br/PT/S1/bg_crash.png": 71326,
	"./br/PT/S1/bg_mine.png": 4440,
	"./br/PT/S1/bg_parity.png": 35445,
	"./br/PT/S1/bigwin.png": 63401,
	"./br/PT/S1/fj.png": 46883,
	"./br/PT/S1/fj2.png": 35541,
	"./br/PT/S1/fjbg6.png": 36897,
	"./br/PT/S1/gm1.png": 48679,
	"./br/PT/S1/gm2.png": 17709,
	"./br/PT/S1/gm3.png": 32246,
	"./br/PT/S1/gm4.png": 1364,
	"./br/PT/S1/gm5.png": 28457,
	"./br/PT/S1/gm6.png": 20404,
	"./br/PT/S1/gm7.png": 71026,
	"./br/PT/S1/toplogo.png": 34294,
	"./br/PT/bg-lose.png": 7337,
	"./br/PT/bg-win.png": 26877,
	"./br/PT/bg03-a.png": 67397,
	"./br/PT/bg03-a_1225.png": 98621,
	"./br/PT/bg03.png": 50906,
	"./br/PT/bg03_1225.png": 84442,
	"./br/PT/bg105.png": 74143,
	"./br/PT/bg115.png": 90212,
	"./br/PT/bg116.png": 95836,
	"./br/PT/bg117.png": 55658,
	"./br/PT/bg13.png": 78443,
	"./br/PT/bg131.png": 98480,
	"./br/PT/bg132.png": 33420,
	"./br/PT/bg142.png": 74652,
	"./br/PT/bg143.png": 32462,
	"./br/PT/bg53.png": 98531,
	"./br/PT/bg55.png": 86701,
	"./br/PT/bg59.png": 9758,
	"./br/PT/bg60.png": 17996,
	"./br/PT/bg62.png": 59749,
	"./br/PT/bg67.png": 99334,
	"./br/PT/bg67b.png": 41490,
	"./br/PT/bg67c.png": 96226,
	"./br/PT/bg76.png": 27198,
	"./br/PT/bg_crash.png": 11971,
	"./br/PT/bg_mine.png": 33820,
	"./br/PT/bg_parity.png": 27975,
	"./br/PT/toplogo.png": 10363,
	"./fj.png": 44493,
	"./fj2.png": 81519,
	"./fj3.png": 51951,
	"./fjbg6.png": 97414,
	"./fjbz.png": 70481,
	"./fjc.png": 63713,
	"./fjf.png": 78568,
	"./fjyw-r.png": 16105,
	"./gm6.png": 7097,
	"./images_ui_item_selected.png": 20517,
	"./img24.png": 28946,
	"./img25.png": 45907,
	"./in/EN/S1/avatar/a1.png": 35943,
	"./in/EN/S1/avatar/a2.png": 2404,
	"./in/EN/S1/avatar/a3.png": 94343,
	"./in/EN/S1/avatar/a4.png": 94248,
	"./in/EN/S1/avatar/a5.png": 51198,
	"./in/EN/S1/avatar/a6.png": 62087,
	"./in/EN/S1/avatar/a7.png": 92119,
	"./in/EN/S1/avatar/a8.png": 85295,
	"./in/EN/S1/avatar/a9.png": 50020,
	"./in/EN/S1/bg07.png": 6838,
	"./in/EN/S1/bg07b.png": 19313,
	"./in/EN/S1/bg105.png": 47229,
	"./in/EN/S1/bg115.png": 19824,
	"./in/EN/S1/bg116.png": 93603,
	"./in/EN/S1/bg117.png": 11220,
	"./in/EN/S1/bg128.png": 30454,
	"./in/EN/S1/bg129.png": 57446,
	"./in/EN/S1/bg13.png": 27013,
	"./in/EN/S1/bg130.png": 23157,
	"./in/EN/S1/bg152-w.png": 76148,
	"./in/EN/S1/bg184.png": 33871,
	"./in/EN/S1/bg185.png": 64849,
	"./in/EN/S1/bg300.png": 94496,
	"./in/EN/S1/bg301.png": 63284,
	"./in/EN/S1/bg53.png": 14501,
	"./in/EN/S1/bg62.png": 12800,
	"./in/EN/S1/bg67.png": 95161,
	"./in/EN/S1/bg67b.png": 83306,
	"./in/EN/S1/bg67b的副本.png": 79122,
	"./in/EN/S1/bg67c.png": 63953,
	"./in/EN/S1/bg76.png": 14505,
	"./in/EN/S1/bg76b.png": 73079,
	"./in/EN/S1/bg901.png": 74532,
	"./in/EN/S1/bg902.png": 33723,
	"./in/EN/S1/bg903.png": 6583,
	"./in/EN/S1/bg904.png": 28644,
	"./in/EN/S1/bg905.png": 18644,
	"./in/EN/S1/bigwin.png": 31273,
	"./in/EN/S1/fj.png": 64080,
	"./in/EN/S1/fj2.png": 79144,
	"./in/EN/S1/fjbg6.png": 64805,
	"./in/EN/S1/gm1.png": 15903,
	"./in/EN/S1/gm2.png": 64122,
	"./in/EN/S1/gm3.png": 75324,
	"./in/EN/S1/gm4.png": 74367,
	"./in/EN/S1/gm5.png": 62321,
	"./in/EN/S1/gm6.png": 9586,
	"./in/EN/S1/gm7.png": 11145,
	"./in/EN/S1/gm7b.png": 29426,
	"./in/EN/bg-lose.png": 96093,
	"./in/EN/bg-win.png": 72450,
	"./in/EN/bg115.png": 41463,
	"./in/EN/bg116.png": 36378,
	"./in/EN/bg117.png": 66926,
	"./in/EN/bg13.png": 81881,
	"./in/EN/bg131.png": 97757,
	"./in/EN/bg132.png": 36082,
	"./in/EN/bg142.png": 8488,
	"./in/EN/bg143.png": 49095,
	"./in/EN/bg55.png": 5215,
	"./in/EN/bg59.png": 45111,
	"./in/EN/bg62.png": 48930,
	"./in/EN/bg62的副本.png": 8024,
	"./in/EN/bg_crash.png": 80262,
	"./in/EN/bg_mine.png": 81294,
	"./in/EN/bg_parity.png": 69808,
	"./in/EN/bg_wheel.png": 38586,
	"./in/EN/toplogo.png": 76533,
	"./ph/EN/S1/avatar/a1.png": 12728,
	"./ph/EN/S1/avatar/a2.png": 99405,
	"./ph/EN/S1/avatar/a3.png": 36920,
	"./ph/EN/S1/avatar/a4.png": 24231,
	"./ph/EN/S1/avatar/a5.png": 79336,
	"./ph/EN/S1/avatar/a6.png": 29327,
	"./ph/EN/S1/avatar/a7.png": 86677,
	"./ph/EN/S1/avatar/a8.png": 11298,
	"./ph/EN/S1/avatar/a9.png": 7199,
	"./ph/EN/S1/bg03-a.png": 66848,
	"./ph/EN/S1/bg03.png": 13191,
	"./ph/EN/S1/bg07.png": 12631,
	"./ph/EN/S1/bg07b.png": 15656,
	"./ph/EN/S1/bg105.png": 74111,
	"./ph/EN/S1/bg115.png": 78875,
	"./ph/EN/S1/bg116.png": 99048,
	"./ph/EN/S1/bg117.png": 34945,
	"./ph/EN/S1/bg128.png": 36175,
	"./ph/EN/S1/bg129.png": 15517,
	"./ph/EN/S1/bg13.png": 61556,
	"./ph/EN/S1/bg130.png": 23842,
	"./ph/EN/S1/bg131.png": 67109,
	"./ph/EN/S1/bg132.png": 65197,
	"./ph/EN/S1/bg184.png": 73532,
	"./ph/EN/S1/bg185.png": 83309,
	"./ph/EN/S1/bg300.png": 88486,
	"./ph/EN/S1/bg301.png": 7722,
	"./ph/EN/S1/bg53.png": 69373,
	"./ph/EN/S1/bg62.png": 6741,
	"./ph/EN/S1/bg67.png": 61164,
	"./ph/EN/S1/bg67b.png": 38902,
	"./ph/EN/S1/bg67c.png": 15298,
	"./ph/EN/S1/bg76.png": 72344,
	"./ph/EN/S1/bigwin.png": 43795,
	"./ph/EN/S1/fj.png": 12512,
	"./ph/EN/S1/fj2.png": 88861,
	"./ph/EN/S1/fjbg6.png": 47086,
	"./ph/EN/S1/gm1.png": 14233,
	"./ph/EN/S1/gm2.png": 99227,
	"./ph/EN/S1/gm3.png": 30741,
	"./ph/EN/S1/gm4.png": 16171,
	"./ph/EN/S1/gm5.png": 10425,
	"./ph/EN/S1/gm6.png": 6913,
	"./ph/EN/S1/gm7.png": 87250,
	"./ph/EN/S1/gm7b.png": 42529,
	"./ph/EN/S2/bigwin.png": 23399,
	"./ph/EN/S2/fj.png": 34366,
	"./ph/EN/S2/fj2.png": 46176,
	"./ph/EN/S2/fjbg6.png": 92360,
	"./ph/EN/bg-lose.png": 81087,
	"./ph/EN/bg-win.png": 332,
	"./ph/EN/bg03-a.png": 90287,
	"./ph/EN/bg03.png": 88367,
	"./ph/EN/bg105.png": 40335,
	"./ph/EN/bg115.png": 35492,
	"./ph/EN/bg116.png": 5644,
	"./ph/EN/bg117.png": 22482,
	"./ph/EN/bg13.png": 28834,
	"./ph/EN/bg131.png": 88787,
	"./ph/EN/bg132.png": 38078,
	"./ph/EN/bg142.png": 28411,
	"./ph/EN/bg143.png": 53403,
	"./ph/EN/bg53.png": 87727,
	"./ph/EN/bg55.png": 12313,
	"./ph/EN/bg59.png": 48815,
	"./ph/EN/bg62.png": 69690,
	"./ph/EN/bg67.png": 46643,
	"./ph/EN/bg67b.png": 60516,
	"./ph/EN/bg67c.png": 55669,
	"./ph/EN/bg76.png": 86770,
	"./ph/EN/bg_crash.png": 16198,
	"./ph/EN/bg_mine.png": 22787,
	"./ph/EN/bg_parity.png": 31994,
	"./ph/EN/logo.png": 88851,
	"./ph/EN/toplogo.png": 58057,
	"./pk1.png": 48442,
	"./pk2.png": 60991,
	"./pk3.png": 85900,
	"./pk4.png": 71630,
	"./pk5.png": 59424,
	"./sicbo/d1.png": 27906,
	"./sicbo/d2.png": 53399,
	"./sicbo/d3.png": 84640,
	"./sicbo/d4.png": 35663,
	"./sicbo/d5.png": 29697,
	"./sicbo/d6.png": 53618,
	"./sicbo/girl_1.png": 16926,
	"./sicbo/girl_2.png": 7377,
	"./sicbo/girl_3.png": 38121,
	"./sicbo/sz01.png": 27273,
	"./sicbo/sz02.png": 37793,
	"./sicbo/sz05.png": 89632,
	"./sicbo/sz05b.png": 2605,
	"./sicbo/sz06.png": 11273,
	"./sicbo/sz07.png": 1037,
	"./sicbo/sz08.png": 58524,
	"./sicbo/sz10.png": 31448,
	"./user1.png": 57354,
	"./user2.png": 20781,
	"./viponly.png": 94347,
	"./vn/VI/S1/avatar/a1.png": 28808,
	"./vn/VI/S1/avatar/a2.png": 61805,
	"./vn/VI/S1/avatar/a3.png": 54200,
	"./vn/VI/S1/avatar/a4.png": 76911,
	"./vn/VI/S1/avatar/a5.png": 90418,
	"./vn/VI/S1/avatar/a6.png": 72104,
	"./vn/VI/S1/avatar/a7.png": 56987,
	"./vn/VI/S1/avatar/a8.png": 48583,
	"./vn/VI/S1/avatar/a9.png": 99341,
	"./vn/VI/S1/bg03-a.png": 20963,
	"./vn/VI/S1/bg03.png": 32561,
	"./vn/VI/S1/bg07.png": 19714,
	"./vn/VI/S1/bg07b.png": 61225,
	"./vn/VI/S1/bg105.png": 78932,
	"./vn/VI/S1/bg115.png": 82393,
	"./vn/VI/S1/bg116.png": 6893,
	"./vn/VI/S1/bg117.png": 7594,
	"./vn/VI/S1/bg128.png": 81421,
	"./vn/VI/S1/bg129.png": 70684,
	"./vn/VI/S1/bg13.png": 64946,
	"./vn/VI/S1/bg130.png": 50390,
	"./vn/VI/S1/bg152-w.png": 9276,
	"./vn/VI/S1/bg184.png": 86946,
	"./vn/VI/S1/bg185.png": 15834,
	"./vn/VI/S1/bg300.png": 54384,
	"./vn/VI/S1/bg301.png": 24731,
	"./vn/VI/S1/bg53.png": 93160,
	"./vn/VI/S1/bg62.png": 20330,
	"./vn/VI/S1/bg67.png": 42560,
	"./vn/VI/S1/bg67b.png": 71380,
	"./vn/VI/S1/bg67c.png": 66229,
	"./vn/VI/S1/bg76.png": 83506,
	"./vn/VI/S1/bigwin.png": 75125,
	"./vn/VI/S1/fj.png": 45892,
	"./vn/VI/S1/fj2.png": 57901,
	"./vn/VI/S1/fjbg6.png": 34402,
	"./vn/VI/S1/gm1.png": 47387,
	"./vn/VI/S1/gm2.png": 56257,
	"./vn/VI/S1/gm3.png": 37442,
	"./vn/VI/S1/gm4.png": 73969,
	"./vn/VI/S1/gm5.png": 34074,
	"./vn/VI/S1/gm6.png": 32335,
	"./vn/VI/S1/gm7.png": 95878,
	"./vn/VI/S1/gm7b.png": 28781,
	"./vn/VI/bg-lose.png": 52824,
	"./vn/VI/bg-win.png": 50518,
	"./vn/VI/bg115.png": 47428,
	"./vn/VI/bg116.png": 43777,
	"./vn/VI/bg117.png": 13522,
	"./vn/VI/bg13.png": 15082,
	"./vn/VI/bg131.png": 34839,
	"./vn/VI/bg132.png": 48265,
	"./vn/VI/bg142.png": 92434,
	"./vn/VI/bg143.png": 37898,
	"./vn/VI/bg55.png": 67199,
	"./vn/VI/bg59.png": 84418,
	"./vn/VI/bg62.png": 97674,
	"./vn/VI/bg_crash.png": 507,
	"./vn/VI/bg_mine.png": 30952,
	"./vn/VI/bg_parity.png": 15217,
	"./vn/VI/bg_wheel.png": 52763,
	"./vn/VI/toplogo.png": 51824,
	"./wifi-g.png": 43039,
	"./wifi-o.png": 88221,
	"./wifi-r.png": 2975,
	"./yes.png": 98139
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;